import { render, staticRenderFns } from "./AccrualsDataCard.vue?vue&type=template&id=a99b9964&scoped=true"
import script from "./AccrualsDataCard.vue?vue&type=script&lang=js"
export * from "./AccrualsDataCard.vue?vue&type=script&lang=js"
import style0 from "./AccrualsDataCard.vue?vue&type=style&index=0&id=a99b9964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99b9964",
  null
  
)

export default component.exports